import React from 'react';
import Layout from 'layouts/Main';
import Register from './Register';

const title = 'Register';

function action(context) {
  return {
    routeName: 'register',
    chunks: ['register'],
    title,
    component: (
      <Layout>
        <Register title={title} />
      </Layout>
    ),
    redirectOnAuthenticated: context.route.redirectOnAuthenticated,
  };
}

export default action;
